module.exports = __webpack_public_path__ + "static/media/TMG Marketing Logo.7ab7f3e1.jpg";